import { useEffect, type RefObject } from 'react';

import { startReportClosedTracking } from '@/lib/reportClosed';

type UsePostHogReportClosedParams = {
  enabled?: boolean;
  reportId?: string | null;
  containerRef?: RefObject<HTMLElement | null>;
};

export const usePostHogReportClosed = ({
  enabled = true,
  reportId,
  containerRef,
}: UsePostHogReportClosedParams) => {
  useEffect(() => {
    if (!enabled || !reportId) return;

    const root = containerRef?.current ?? document;
    return startReportClosedTracking(root);
  }, [enabled, reportId, containerRef]);
};
